import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DynamicSwitchGroupForm from 'components/DynamicSwitchGroup/DynamicSwitchGroupForm';
import CodexVersionDisplayBar from 'components/CodexVersionDisplayBar';

const DynamicSwitchGroup = () => {
  const location = useLocation();
  const codexVersionIdFromState = location.state?.params?.codexVersionId;
  const codexVersionIdFromRedux = useSelector((state) => 
    state.codexVersion ? state.codexVersion.codexVersionId : null
  );
  const codexVersionId = codexVersionIdFromState || codexVersionIdFromRedux;

    return (
      <Container fluid>
        <CodexVersionDisplayBar />
        <Row>
          <Col xs={12}>
          <DynamicSwitchGroupForm codexVersionId={codexVersionId} />
          </Col>
        </Row>
      </Container>
    );
};

export default DynamicSwitchGroup;

